import AssetService from '@/services/AssetService';

export const PopupMessage = ({ popupId, onClose, children }) => {
  const setPopup = useAppStore((state) => state.setPopup);

  const _onClose = useCallback(() => {
    setPopup(null);
    onClose();
    AssetService.getAsset('s_button').play();
  }, [onClose]);

  return (
    <Popup
      popupId={popupId}
      className="popup-message font-gellix w-[26.4rem] text-[1.8rem] leading-[1.18] font-semibold tracking-[0.02em]"
      bg={false}
      onClose={_onClose}
    >
      <img
        src="/assets/images-next/message.webp"
        className="relative scale-[1.28]"
      />
      <div
        className="full flex-center-col px-3 pt-7 pb-3"
        onClick={_onClose}
      >
        <div className="typo-h2 my-3 text-center">{children}</div>
      </div>
    </Popup>
  );
};
